import { make as makeField } from './Field.gen'

type FieldProps = React.ComponentProps<typeof makeField>

const Field = makeField as React.FunctionComponent<FieldProps>

export { Field, type FieldProps }
